<div class="customer-info row-block">
	<div class="customer-label">
		Name:
	</div>
	<div class="customer-span">
		{{project.customer?.name}}
	</div>
</div>
<div class="customer-info row-block" >
	<div class="customer-label">
		Phone #1:
	</div>
	<div class="customer-span margin-left-customer" (click)="callPhone()">
		{{project.customer?.billingInfoContact?.phone1}}
		<!-- {{transform(project.customer?.billingInfoContact?.phone1)}} -->
	</div>
</div>
<div class="customer-info row-block">
	<div class="customer-label">
		E-Mail:
	</div>
	<div class="customer-span margin-left-customer" (click)="sendEmail()">
		{{project.customer?.billingInfoContact?.email}}
	</div>
</div>
